export default __webpack_public_path__ + "static/media/not-found.8a4510fe.svg";